import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { rate: Number }

  connect() {
    this.element.playbackRate = this.rateValue
  }
}
